import { useMemo } from "react";
import { useTranslation } from "translation/useTranslation";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { formatNumberTo } from "helpers/common";

export default function EvaluationStats({ id = null, data = {}, hasError = false, centered = true, thirdCol = true, displayLineAfter = false }) {
  const { editableTranslate } = useTranslation();

  const opacityDistance = useMemo(() => {
    return Math.round(100 / data?.distributions?.length);
  }, [data]);

  const cleanedData = useMemo(() => {
    const newData = structuredClone(data);

    if (newData?.ratio && newData?.ratio?.toString().includes(',')) newData.ratio = formatNumberTo(newData?.ratio, '.');

    if (newData?.distributions) {
      for (const item of newData?.distributions) {
        if (item?.ratio && item?.ratio?.toString().includes(',')) item.ratio = formatNumberTo(item?.ratio, '.');
      }
    }

    return newData;
  }, [data]);

  return <div className={`bg-white w-100 ${hasError ? 'my-4' : 'mb-4'}`}>
    <div className={`row ${centered ? 'justify-content-center' : ''}`}>
      <div className="col-4 max-w-500">
        <div className="simple-stats-tile d-flex align-items-center">
          {
            !cleanedData?.hasOwnProperty('total') ? <div className="w-100 text-center" data-testid="loading">
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="sr-only">Wird geladen...</span>
              </div>
            </div> : <div className="w-100">
              <div className="text-right mb-2">
                <span className="font-weight-bold mr-1">{cleanedData?.evaluated} / {cleanedData?.total}</span>
                <span className="gray">{editableTranslate('state_employee.evaluated', 'Beurteilt')}</span>
              </div>
              <div className="single-value-bar" data-tooltip-id={(id ? id + '-' : '') + `stats-evaluated-tooltip`}>
                <div style={{ 'width': (cleanedData?.ratio || 0) + '%' }}></div>
              </div>

              <ReactTooltip id={(id ? id + '-' : '') + `stats-evaluated-tooltip`} content={`${cleanedData?.ratio}%`} place="bottom" />
            </div>
          }
        </div>
      </div>

      <div className="col-4 max-w-500">
        <div className="simple-stats-tile">
          <div className="gray font-weight-bold mb-3">{editableTranslate('state_employee.result_distribution', 'Ergebnisverteilung')}</div>

          {
            !cleanedData?.hasOwnProperty('distributions') ? <div className="w-100 text-center" data-testid="loading">
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="sr-only">Wird geladen...</span>
              </div>
            </div> : <>
              {
                (!cleanedData?.distributions || cleanedData?.distributions?.length === 0) && <>
                  <div className="single-value-bar" data-tooltip-id={`empty-stats-distribution-tooltip`}>
                    <div style={{ 'width': '0%' }}></div>
                  </div>

                  <ReactTooltip id={`empty-stats-distribution-tooltip`} content={`0%`} place="bottom" />
                </>
              }
              {
                cleanedData?.distributions?.length > 0 && <div className="multiple-value-bar">
                  {
                    cleanedData?.distributions?.map((dist, i) => <div key={i}
                      data-tooltip-id={(id ? id + '-' : '') + `stats-distribution-${i}-tooltip`}
                      className={i < cleanedData?.distributions?.length - 1 ? 'opacity-' + (opacityDistance * (i + 1)) : ''}
                      style={{ 'width': (dist?.ratio || 0) + '%' }}>
                    </div>)
                  }
                </div>
              }
              {
                cleanedData?.distributions?.length > 0 &&
                <div className="multiple-value-bar-label mt-1">
                  {
                    cleanedData?.distributions?.map((dist, i) => <div key={i}
                      data-tooltip-id={(id ? id + '-' : '') + `stats-distribution-${i}-tooltip`}
                      className="gray text-uppercase font-weight-bold"
                      style={{ 'width': (dist?.ratio || 0) + '%', 'maxWidth': (dist?.ratio || 0) + '%', 'minWidth': '35px' }}>
                      <span
                        className={i < cleanedData?.distributions?.length - 1 ? 'opacity-' + (opacityDistance * (i + 1)) : ''}></span>{dist?.label}
                    </div>)
                  }
                </div>
              }
            </>
          }

          {
            cleanedData?.distributions?.map((dist, i) => <ReactTooltip key={i} id={(id ? id + '-' : '') + `stats-distribution-${i}-tooltip`} content={`${dist?.label}: ${dist?.count} (${dist?.ratio}%)`} place="bottom" />)
          }
        </div>
      </div>

      {
        thirdCol && <div className="col-4 max-w-500">
          <div className="simple-stats-tile empty"></div>
        </div>
      }
    </div>

    {
      displayLineAfter && <div className={`row ${centered ? 'justify-content-center' : ''}`}>
        <div className={`${thirdCol ? 'col-12 max-w-1500' : 'col-8 max-w-1000'} mt-3`}>
          <hr className="mb-1" />
        </div>
      </div>
    }
  </div>;
}